import { Button } from "antd";

function ReportCard({
  icon,
  title,
  detail,
  onClick,
  containerTestId,
  viewButtonTestId,
  ...rest
}: {
  icon: any;
  title: string;
  detail: any;
  onClick: () => void;
  containerTestId?: string;
  viewButtonTestId?: string;
} & React.HTMLAttributes<HTMLDivElement>) {
  const containerAttrs = containerTestId
    ? ({
        "data-testid": containerTestId
      } as any)
    : ({} as any);

  return (
    <div
      {...containerAttrs}
      {...rest}
      className="flex flex-col w-[319px] h-[380px] rounded border-solid border-ciq-gray-100 bg-white border mt-5"
    >
      <div className="w-full font-medium text-sm items-center py-2 px-3 border-0 border-b border-solid border-ciq-gray-100">
        {title}
      </div>
      <div className="grow">
        <div className="h-full px-4">
          <div className="p-1 py-6 text-center">{icon}</div>
          <div className="px-1 text-sm">{detail}</div>
        </div>
      </div>
      <div className="p-4">
        <Button
          type="primary"
          className="h-8 w-full "
          onClick={onClick}
          data-testid={viewButtonTestId}
        >
          View
        </Button>
      </div>
    </div>
  );
}
export default ReportCard;
